import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddSchedule = () => {
  const navigate = useNavigate();

  // State to hold form data
  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const dataToSend = {
      name: formData.name,
      remark: formData.remark,
      active: formData.active,
    };

    try {
      await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogSchedulerOperation/Insert',
        dataToSend,
        {
          headers: {
            "X-Authorization": token,
            "UserId": userid,
            "Content-Type": "application/json",
          },
        }
      );
      setMessage("Schedule added successfully!");

      // Navigate to another page after 3 seconds
      setTimeout(() => {
        navigate("/schedulelist");
      }, 3000);
    } catch (error) {
      setMessage("Failed to add schedule.");
    }
  };

  // Handle input change for text and file inputs separately
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Save text input value
    }));
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Schedule</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Schedule Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter schedule name"
                                name="name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Schedule Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter description"
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select 
                                className="form-control" 
                                name="active" 
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "Schedule added successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to add schedule." ? (
       <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default AddSchedule;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
